<!-- The first header is only there for accessibility purposes. The "skip to"-feature will not find the component if not included -->
<h2 class="widget-header h4 d-none">Power BI</h2>
<div *ngIf="powerBIFrames$ | async as frames" class="d-flex flex-wrap mb-2">
  <h2 *ngIf="selectedFrame && selectedFrame.ShowTitle" class="widget-header h4">{{selectedFrame.Title}}</h2>
  <div class="ml-md-auto">
    <div *ngIf="frames && frames.length > 1" class="d-flex">
      <span class="bolder" i18n="@@powerBI-frame-list-title" id="powerBI_label">Report</span>:
      <div class="ml-1 powerBIFrame-selector-container focus-border">
        <mat-select (selectionChange)="handleSelection($event)" role="listbox" placeholder="Select a report" [(value)]="selectedFrame" i18n-aria-label="@@powerBI-reports" aria-label="Reports">
          <mat-option *ngFor="let frame of frames" role="option" [value]="frame">{{frame.Title}}</mat-option>
        </mat-select>
      </div>
    </div>
  </div>
</div>

<div *ngIf="userAccessToken$ | async as accessToken">
  <div *ngIf="selectedFrame$ | async as selectedFrame">
    <app-power-bi-frame [selectedFrame]='selectedFrame' [accessToken]='accessToken'></app-power-bi-frame>
  </div>
</div>
